<google-map [height]="height"
            [width]="width"
            (mapInitialized)="onMapInitialized($event)"
            [center]="center"
            [zoom]="zoom"
            [options]="options"
            mapId="changeMe"
            [mapId]="mapId">
</google-map>
